import React, { PureComponent } from 'react';
/* eslint-disable */
import { MY_API_URL } from '../Apanel/QueryMe';
import { withRouter } from 'react-router-dom';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	image: dimgurl,
};

class ProfileImage extends PureComponent {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };

	render() {
		const { image, noimg } = this.state;

		return (
			<img
				className={this.props.clname}
				src={this.props.flpath == '0' ? this.state.image : this.props.flpath}
				alt="avatar"
			/>
		);
	}
}

export default withRouter(ProfileImage);
